module.exports = __webpack_public_path__ + "static/media/geography.d502df1a.jpg";